import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendolaCompatible = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "uuid-809de3f3-7a1b-4edc-b5c2-bb1a54686513",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M78.56,24.82v2.02l-19.15,54.28c-.59,1.67-1.69,2.43-3.15,3.03h-1.95c-1.36-.8-2.28-1.74-2.96-3.27l-9.83-22.11-22.84-10.17c-1.58-.7-2.56-2.35-2.48-3.96.08-1.48,1.03-3.09,2.65-3.66l54.09-18.94c1.98-.69,3.8-.1,4.93,1.68l.7,1.1ZM55.71,47.9l-9.52,9.55,9.21,20.65,17.89-51.11-51.1,17.89,20.61,9.19,9.6-9.56c1.14-.56,2.35-.43,3.1.4.7.78.87,1.96.21,2.99Z" })
});
export default SvgSendolaCompatible;
